
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop, Ref} from 'vue-property-decorator';
  import {validators} from '@/utils/validations';

  @Component({})
  export default class EmailDynamic extends Vue {

    @Prop({required: false, default: 3}) initialFields!: number;
    emails: string[] = new Array<string>(3);
    rules = validators;
    valid = false;

    // @ts-ignore
    @Ref() form: VForm;

    mounted() {
      this.emails = new Array<string>(this.initialFields)
    }

    emailRules(index: number): (string | boolean)[] {
      if (this.emails[index] !== undefined && this.emails[index].length > 0) {
        return [this.rules.email(this.emails[index])]
      } else {
        return []
      }
    }

    @Emit()
    onEmailEnter(): string[] {
      return this.emails;
    }

    onAddMoreEmails() {
      this.emails.push('')
    }

    onRemoveEmailField(index: number) {
      if (index > 0) {
        this.emails.splice(index, 1)
      }
    }

    onFocusOut() {
      if (this.form.validate()) {
        this.onEmailEnter();
      }
    }
  }
